/**
 * Created by Carsten Bühler
 * User: CBuehler on 29.10.2015
 * Copyright: xdot GmbH 2015
 */

import { FormActions, RemoteDataActions } from 'plugin/liferay-widgets-react-web';

import StateWebApi from '../webapi/StateWebApi';
import { ClassNames } from '../constants/Constants';

export default {

    load: () => RemoteDataActions.list('all', ClassNames.State, {}, StateWebApi.loadStatesFromService),

    list: (name, query) => RemoteDataActions.list(name, ClassNames.State, query, StateWebApi.loadStatesFromService),
    item: (name, query) => RemoteDataActions.item(name, ClassNames.State, query, StateWebApi.loadStateFromService),

    attachedList: (name, byId, byClassName, query) =>
        RemoteDataActions.attachedList(name, ClassNames.State, StateWebApi.loadStatesFromService, byId, byClassName, query),

    attachedItem: (name, byId, byClassName, query) =>
        RemoteDataActions.attachedItem(name, ClassNames.State, StateWebApi.loadStateFromService, byId, byClassName, query),

    moreItems: (name, query) => RemoteDataActions.moreItems(name, ClassNames.State, query),

    createItem: (item, actionData) => FormActions.submitForm(StateWebApi.addState, item, actionData).key,
    updateItem: (item, actionData) => FormActions.submitForm(StateWebApi.editState, item, actionData).key,
    deleteItem: (item, actionData) => FormActions.submitForm(StateWebApi.deleteState, item, actionData).key

};



// WEBPACK FOOTER //
// ./js/actions/StateActions.js